"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReloadPageInterval = void 0;
const react_1 = require("react");
function useReloadPageInterval(interval) {
    react_1.useEffect(() => {
        const timeout = setTimeout(() => {
            window.location.reload();
        }, interval);
        return () => {
            clearTimeout(timeout);
        };
    }, [interval]);
}
exports.useReloadPageInterval = useReloadPageInterval;
//# sourceMappingURL=useReloadPageInterval.js.map